import { render, staticRenderFns } from "./InvoicePublication.vue?vue&type=template&id=60e0848a&"
import script from "./InvoicePublication.vue?vue&type=script&lang=js&"
export * from "./InvoicePublication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports